import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Switch,
    Button,
    IconButton,
} from "@mui/material";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CollectionsBookmarkOutlinedIcon from '@mui/icons-material/CollectionsBookmarkOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import SearchBar from "../../components/SearchBar";

const VendorBlogs = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    // Dummy blog data
    const blogsData = [
        {
            thumbnail: "/static/images/placeholder.png",
            userimage: "/static/images/user_placeholder.png",
            username: "Alice",
            useremail: "Alice@exmaple.com",
            title: "How to Build a Web App",
            description: "A step-by-step guide to building a full-stack web application.",
            time: "10 min read",
            tags: "Web Development, React, JavaScript",
        },
        {
            thumbnail: "/static/images/placeholder.png",
            username: "Alice",
            useremail: "Alice@exmaple.com",
            userimage: "/static/images/user_placeholder.png",
            title: "Understanding CSS Grid",
            description: "Master the art of creating layouts with CSS Grid.",
            time: "7 min read",
            tags: "CSS, Web Design, Frontend",
        },
        {
            thumbnail: "/static/images/placeholder.png",
            username: "Alice",
            useremail: "Alice@exmaple.com",
            userimage: "/static/images/user_placeholder.png",
            title: "Introduction to Python for Beginners",
            description: "Learn the basics of Python programming language in this beginner-friendly tutorial.",
            time: "12 min read",
            tags: "Python, Programming, Backend",
        },
    ];

    // State for toggles per blog
    const [toggles, setToggles] = useState(
        blogsData.map(() => ({
            makeBanner: false,
            makerOfMonth: false,
            featuredAdvisor: false,
        }))
    );

    const handleToggle = (index: number, field: string) => {
        setToggles((prev) =>
            prev.map((item, i) =>
                i === index ? { ...item, [field]: !item[field as keyof typeof item] } : item
            )
        );
    };

    return (
        <div className="vendor_blogs_page">
            <div className="main_title">
                <h1>Vendor Journals</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Vendor Journals
                </p>
            </div>

            <div className="stats_boxes gap_m">
                {/* Total Posts */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            128
                            <p>Total Posts <br /> <small style={{ fontSize: '11px', color: '#717171' }}>by Vendors</small></p>
                        </h2>
                        <figure className="warning">
                            <CollectionsBookmarkOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </div>

                {/* Featured This Month */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            12
                            <p>Featured <br /> <small style={{ fontSize: '11px', color: '#717171' }}>This Month</small></p>
                        </h2>
                        <figure className="warning">
                            <AutoAwesomeIcon fontSize="large" />
                        </figure>
                    </div>
                </div>

                {/* Active Vendors */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            85
                            <p>Active <br /> <small style={{ fontSize: '11px', color: '#717171' }}>Contributors</small></p>
                        </h2>
                        <figure className="warning">
                            <LightbulbOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </div>
            </div>

            <div className="table_flex mt_20">
                <div className="lt">
                    <div className="cards">
                        <div className="table_header">
                            <Box className="search_box">
                                <SearchBar
                                    searchTerm={searchTerm}
                                    setDebouncedSearchTerm={setSearchTerm}
                                    placeholder="Search by blog title or tag..." />
                            </Box>
                        </div>
                        <TableContainer className="table_container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Sr. No.</TableCell>
                                        <TableCell>User Details</TableCell>
                                        <TableCell>Thumbnail</TableCell>
                                        <TableCell>Title</TableCell>
                                        <TableCell>Description</TableCell>
                                        <TableCell>Time</TableCell>
                                        <TableCell>Tags</TableCell>
                                        <TableCell>Make Banner</TableCell>
                                        <TableCell>Maker of the Month</TableCell>
                                        <TableCell>Featured Advisor</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {blogsData.map((blog, index) => (
                                        <TableRow key={index} hover>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>
                                                <div className="user_block no_radius">
                                                    <figure>
                                                        <img src={blog.userimage} alt={blog.title} />
                                                    </figure>
                                                    <p>
                                                        <b>{blog.username}</b>
                                                        {blog.useremail}
                                                    </p>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="user_block">
                                                    <figure>
                                                        <img src={blog.thumbnail} alt={blog.title} />
                                                    </figure>
                                                </div>
                                            </TableCell>
                                            <TableCell>{blog.title}</TableCell>
                                            <TableCell >{blog.description}</TableCell>
                                            <TableCell>{blog.time}</TableCell>
                                            <TableCell>{blog.tags}</TableCell>

                                            {/* Toggles */}
                                            <TableCell>
                                                <Switch
                                                    checked={toggles[index].makeBanner}
                                                    onChange={() => handleToggle(index, "makeBanner")} />
                                            </TableCell>
                                            <TableCell>
                                                <Switch
                                                    checked={toggles[index].makerOfMonth}
                                                    onChange={() => handleToggle(index, "makerOfMonth")} />
                                            </TableCell>
                                            <TableCell>
                                                <Switch
                                                    checked={toggles[index].featuredAdvisor}
                                                    onChange={() => handleToggle(index, "featuredAdvisor")} />
                                            </TableCell>
                                            <TableCell>
                                                <div className="table_actions v2">
                                                    <Box>
                                                        <IconButton onClick={() => navigate("view")}>
                                                            <img src="/static/images/eye_icon.svg" alt="" />
                                                        </IconButton>
                                                    </Box>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>

                <div className="rt">
                    <div className="ai_content_ideas_wrapper">
                        {/* Featured Idea Card */}
                        <div className="content_idea_card">
                            <div className="card_image">
                                <img src="/static/images/placeholder.png" alt="Decor" />
                            </div>
                            <h3>Vendor performance AI</h3>
                            <div className="idea_content">
                                <LightbulbOutlinedIcon className="icon" style={{ fontSize: 16, color: '#d97706' }} />
                                <div className="text">
                                    <h4>Top performing vendor: Alice</h4>
                                    <p>Her latest post "How to Build a Web App" has reached 5k reads in 24 hours.</p>
                                </div>
                            </div>
                            <button className="generate_btn">
                                <AutoAwesomeIcon style={{ fontSize: 14 }} /> Performance Report
                            </button>
                        </div>
                    </div>

                    <div className="ai_panel">
                        <h4>Vendor Insights</h4>

                        <div className="ai_alert warning">
                            <span className="icon">⚠️</span>
                            <p>
                                <b>3 Vendors</b> haven't posted in 30 days
                            </p>
                        </div>

                        <div className="ai_alert success">
                            <span className="icon">✨</span>
                            <p>
                                <b>82%</b> average post quality score
                            </p>
                        </div>

                        <small className="ai_update">
                            Next sync ETA: <b>2 Hours</b>
                        </small>

                        <div className="ai_sku_list">
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>Rising Star</h5>
                                    <p>Sarah Potter's engagement is up 40%</p>
                                </div>
                            </div>

                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>SEO Tip</h5>
                                    <p>Suggest keywords for John Maker's next post</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VendorBlogs;
